module.exports = __webpack_public_path__ + "media/application/images/hero@2x-1e1a7184e674dc60d56e9dc152efadbcc9a2768a9687559b6e6dfb5d6bdb32ea.png";